import React from "react";
import { NavLink } from "react-router-dom";
import { BadgeDollarSign, Heart, Package, Star, Ticket, Trophy, Users } from "lucide-react";

const cx = (...arr) => arr.filter(Boolean).join(" ");

const B2CHeader = () => {
  const navItems = [
    {
      path: "/manage-admin/b2c/customers",
      label: "Customers",
      Icon: Users,
    },
    {
      path: "/manage-admin/b2c/orders",
      label: "Orders",
      Icon: Package,
    },
    {
      path: "/manage-admin/b2c/wishlist",
      label: "Wishlist & Cart",
      Icon: Heart,
    },
    {
      path: "/manage-admin/b2c/reviews",
      label: "Reviews & Feedback",
      Icon: Star,
    },
    {
      path: "/manage-admin/b2c/pricing",
      label: "Pricing Rules",
      Icon: BadgeDollarSign,
    },
    {
      path: "/manage-admin/b2c/coupons",
      label: "Coupons & Sales",
      Icon: Ticket,
    },
    {
      path: "/manage-admin/b2c/loyalty",
      label: "Loyalty & Referrals",
      Icon: Trophy,
    },
  ];

  return (
    <div className="bg-white border border-slate-200 rounded-2xl p-2">
      <div className="flex flex-wrap items-center gap-2">
        {navItems.map(({ path, label, Icon }) => (
          <NavLink
            key={path}
            to={path}
            className={({ isActive }) =>
              cx(
                "inline-flex items-center gap-2 rounded-2xl px-3 py-2 text-sm font-semibold transition-colors",
                isActive
                  ? "bg-slate-900 text-white"
                  : "bg-slate-50 border border-slate-200 text-slate-700 hover:bg-white hover:text-slate-900"
              )
            }
          >
            <Icon className="h-4 w-4" />
            <span className="hidden sm:inline">{label}</span>
          </NavLink>
        ))}
      </div>
    </div>
  );
};

export default B2CHeader;
